import { StyledRequired } from "./styles";

export default function SmallStyled({ children }: any) {
  return <StyledRequired>{children}</StyledRequired>;
}

